import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	apps: [],
	isLoading: false,
	error: false,
};

const appsSlice = createSlice({
	name: 'apps',
	initialState,
	reducers: {
		storeApps: (state, action) => {
			state.apps = action.payload;
		},
	},
});

export const selectAllApps = (state) => {
	return state.apps;
};

export const { storeApps } = appsSlice.actions;

export default appsSlice.reducer;
